import { render } from "./payout.vue?vue&type=template&id=5925fb90&scoped=true&ts=true"
import script from "./payout.vue?vue&type=script&lang=ts"
export * from "./payout.vue?vue&type=script&lang=ts"

import "./payout.vue?vue&type=style&index=0&id=5925fb90&lang=less&scoped=true"
import "./payout.vue?vue&type=style&index=1&id=5925fb90&lang=less"

import exportComponent from "/data/gitlab/pay.klicklpay.com/KlicklPaymentPage/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5925fb90"]])

export default __exports__